import React from "react";
import { FormControl, Select, MenuItem, Typography } from "@mui/material";
import "./style.css";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";
import { ReactComponent as Urgent } from "../../../../assets/images/TicketImages/urgent.svg";
import { ReactComponent as High } from "../../../../assets/images/TicketImages/high.svg";
import { ReactComponent as Medium } from "../../../../assets/images/TicketImages/medium.svg";
import { ReactComponent as Low } from "../../../../assets/images/TicketImages/low.svg";
import { Height } from "@mui/icons-material";
function TicketDropdowns({
  status = "open",
  setStatus,
  priority = "medium",
  setPriority,
}) {
  const statusOptions = ["open", "pending", "solved", "spam"];
  const priorityOptions = [
    { value: "urgent", label: "Urgent" },
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" },
  ];

  return (
    <>

      <FormControl size="small" sx={{
        width: "100%",

        "& .MuiSelect-icon": {
          fontSize: "16px",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .MuiSelect-iconOpen": {
          fontSize: "16px",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%) rotate(180deg)",
          right: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      }}>
        <div className="field-wrapper">
          <h3 className="field-label">Priority</h3>
          <Select
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            IconComponent={Dropdown}
            displayEmpty
            sx={{
              fontSize: "14px",
              color: "#405261",


              "& .MuiSelect-select": {
                padding: "0px 16px !important", // ✅ override default
                display: "flex",
                alignItems: "center",
              },


              "& .MuiOutlinedInput-input": {
                padding: "0px 16px !important", // ✅ override variant-specific padding
              }
            }}

            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #D5DCE1",
                  marginTop: "8px",
                  width: "100%px",

                  borderRadius: "8px",
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                  "& .MuiMenuItem-root": {
                    fontSize: "14px",
                    fontFamily: 'Inter',
                    color: "#556575",
                    borderRadius: '4px',
                    padding: '0px 8px',
                    marginLeft: '8px',
                    marginRight: '8px',
                    height: '32px',
                    marginTop: '5px',
                    fontWeight: '400',
                    '&:hover': {
                      color: '#061522',
                      borderRadius: "8px",
                      background: "#F9FAFA",
                    },
                    '&.Mui-selected': {
                      padding: '0px 8px',
                      marginLeft: '8px',
                      marginRight: '8px',
                      height: '32px',
                      marginTop: '5px',
                      fontSize: "14px",
                      fontFamily: 'Inter',
                      fontWeight: '400',
                      backgroundColor: '#F9FAFA',
                      color: '#061522',
                    },
                  },
                },
              },
            }}
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <Typography
                    sx={{
                      color: "#405261",
                      fontSize: "14px",
                    }}
                  >
                    Set priority
                  </Typography>
                );
              }
              const selectedOption = priorityOptions.find(
                (option) => option.value === selected
              );
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: selected === "low" ? "15px" : "8px",
                  }}
                >
                  {selected === "urgent" && <Urgent />}
                  {selected === "high" && <High />}
                  {selected === "medium" && <Medium />}
                  {selected === "low" && (
                    <Low style={{ marginLeft: "5px" }} />
                  )}
                  {selectedOption
                    ? selectedOption.label
                    : selected.charAt(0).toUpperCase() + selected.slice(1)}
                </div>
              );
            }}
          >
            {priorityOptions.map((option) => (
              <MenuItem key={option.value} value={option.value} >
                <div style={{ display: "flex", alignItems: "center", gap: option.value === "low" ? "15px" : "8px" }}>
                  {option.value === "urgent" && <Urgent />}
                  {option.value === "high" && <High />}
                  {option.value === "medium" && <Medium />}
                  {option.value === "low" && <Low style={{ marginLeft: "5px" }} />}
                  &nbsp;{option.label}
                </div>
              </MenuItem>
            ))}
          </Select>
        </div>
      </FormControl>
      <FormControl size="small" sx={{
        width: "100%",

        "& .MuiSelect-icon": {
          fontSize: "16px",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .MuiSelect-iconOpen": {
          fontSize: "16px",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%) rotate(180deg)",
          right: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      }}>
        <div className="field-wrapper">
          <h3 className="field-label">Status</h3>
          <Select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            IconComponent={Dropdown}
            displayEmpty
            sx={{
              fontSize: "14px",
              color: "#405261",

              // Remove default padding and set custom 16px padding
              "& .MuiSelect-select": {
                padding: "0px 16px !important", // ✅ override default
                display: "flex",
                alignItems: "center",
              },

              // For outlined variant (ensures no extra padding is left)
              "& .MuiOutlinedInput-input": {
                padding: "0px 16px !important", // ✅ override variant-specific padding
              }
            }}
            // style={{
            //   display: 'flex',
            //   justifyContent: 'space-between',
            //   fontSize: '12px',
            //   fontWeight: '500',
            //   width: '100%',
            //   textTransform: 'capitalize',
            // }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #D5DCE1",
                  marginTop: "8px",
                  width: "100%px",

                  borderRadius: "8px",
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                  "& .MuiMenuItem-root": {
                    fontSize: "14px",
                    fontFamily: 'Inter',
                    color: "#556575",
                    borderRadius: '4px',
                    padding: '0px 8px',
                    marginLeft: '8px',
                    marginRight: '8px',
                    height: '32px',
                    marginTop: '5px',
                    fontWeight: '400',
                    '&:hover': {
                      color: '#061522',
                      borderRadius: "8px",
                      background: "#F9FAFA",
                    },
                    '&.Mui-selected': {
                      padding: '0px 8px',
                      marginLeft: '8px',
                      marginRight: '8px',
                      height: '32px',
                      marginTop: '5px',
                      fontSize: "14px",
                      fontFamily: 'Inter',
                      fontWeight: '400',
                      backgroundColor: '#F9FAFA', // selected item background
                      color: '#061522',
                    },
                  },
                },
              },
            }}
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <Typography style={{
                    color: '#405261',
                    fontSize: '14px'
                  }}>Set status</Typography>
                );
              }
              return selected.charAt(0).toUpperCase() + selected.slice(1);
            }}
          >
            {statusOptions.map((option) => (
              <MenuItem key={option} value={option} style={{ fontSize: '12px', transform: 'capitalize' }}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </div>
      </FormControl>

    </>
  );
}

export default TicketDropdowns;
